import React, { Component } from 'react';
import { motion } from 'framer-motion';
const WHATSAPP_NUMBER = '584244582867';
const buildWaLink = (service: string) => {
  const message = `Hola PinzColors, quisiera agendar una cita para ${service}.`;
  return `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`;
};
const services = [{
  title: 'Soft Gel',
  price: '17€',
  description: 'Acabado natural y resistente, perfecto para uñas que respiran elegancia día tras día.',
  image: 'https://cdn.magicpatterns.com/uploads/rPQtYxef2HsnTFEd4kS67s/SOFT_GEL.jpg'
}, {
  title: 'Kapping con Polygel',
  price: '15€',
  description: 'Refuerzo ligero que protege y embellece tu uña natural sin sacrificar comodidad.',
  image: 'https://cdn.magicpatterns.com/uploads/9TKW3tqUrRBvN3Hmr2ucj7/POLYGEL.jpg'
}, {
  title: 'Semipermanente',
  price: '12€',
  description: 'Color impecable de larga duración con un brillo de salón en cada detalle.',
  image: 'https://cdn.magicpatterns.com/uploads/oGrun2pBLqPbbUNyj8FGhZ/Semipermanente.jpg'
}];
export const Services = () => {
  return <section id="servicios" className="scroll-mt-40 py-24 md:py-32 px-6 md:px-12 max-w-7xl mx-auto" data-id="element-183">
      <motion.div initial={{
      opacity: 0,
      y: 30
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.7
    }} className="text-center mb-16 md:mb-20" data-id="element-184">
        <span className="font-sans text-xs tracking-[0.2em] uppercase text-brand-charcoal/60" data-id="element-185">
          Servicios & Precios
        </span>
        <h2 className="font-serif text-5xl md:text-6xl text-brand-charcoal mt-4" data-id="element-186">
          Rituales de <span className="italic" data-id="element-187">belleza</span>
        </h2>
        <p className="font-sans font-light text-sm text-brand-charcoal/60 mt-6 max-w-md mx-auto" data-id="element-188">
          Toca cualquier servicio para agendar tu cita directamente por
          WhatsApp.
        </p>
      </motion.div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-10" data-id="element-189">
        {services.map((service, idx) => <motion.a key={service.title} href={buildWaLink(service.title)} target="_blank" rel="noreferrer" initial={{
        opacity: 0,
        y: 40
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-60px'
      }} transition={{
        duration: 0.7,
        delay: idx * 0.15,
        ease: [0.22, 1, 0.36, 1]
      }} whileHover={{
        y: -6
      }} className="glass-panel rounded-[36px] p-6 md:p-8 flex flex-col transition-shadow duration-500 hover:shadow-[0_20px_60px_rgba(0,0,0,0.12)] cursor-pointer group" aria-label={`Agendar cita para ${service.title} por WhatsApp`} data-id="element-190">
            {/* Image */}
            <div className="relative aspect-[4/5] rounded-[24px] overflow-hidden mb-6 shadow-[0_15px_35px_-10px_rgba(0,0,0,0.35)]" data-id="element-191">
              <img src={service.image} alt={service.title} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" data-id="element-192" />
            </div>

            <div className="flex items-start justify-between gap-4 mb-3" data-id="element-193">
              <h3 className="font-serif text-2xl md:text-3xl text-brand-charcoal leading-tight" data-id="element-194">
                {service.title}
              </h3>
              <span className="font-serif italic text-3xl md:text-4xl text-brand-charcoal shrink-0" data-id="element-195">
                {service.price}
              </span>
            </div>
            <p className="font-sans font-light text-sm leading-relaxed text-brand-charcoal/70 mb-4" data-id="element-196">
              {service.description}
            </p>

            <span className="mt-auto font-sans text-[11px] tracking-[0.25em] uppercase text-brand-charcoal/50 group-hover:text-brand-charcoal transition-colors duration-300" data-id="element-197">
              Agendar →
            </span>
          </motion.a>)}
      </div>
    </section>;
};